// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".ant-modal-root .ant-modal-content{z-index:1000000000000000000000000}.modal-backdrop{z-index:auto}.studioModal{z-index:auto}.lsf-tooltip{z-index:100000000000000000000000}.lsf-keys__key{color:black}\n", ""]);
// Exports
module.exports = exports;
